/*
The buyer search URL carries its filters in a single path SEGMENT rather than a query string:

    /search-results/:keyword/:search          (MainApp.js)

where :search is `search=<text>&company=&seller=&discount=&sortBy=price`, each part written with
encodeURIComponent (components/buyersHeader, bSearchResults/categoryList).

Two things make that segment easy to read wrongly, and reading it wrongly white-screened the page:

1. useParams() hands the segment back ALREADY percent-decoded, so a product name containing '&' -
   "ZERCLONAC COLD & FLU TABLETS 10S" - arrives as a bare '&', by then indistinguishable from the
   separators between the filters. Anything that splits the DECODED string on '&' tears the name in
   half and loses everything after it. So what must be split is the raw, still-encoded segment, and
   that is what location.pathname holds - react-router decodes the params, never the pathname.

2. The separators have to be split off BEFORE percent-decoding, never after. URLSearchParams does
   exactly that, in that order, which is why it replaces the hand-rolled

       JSON.parse('{"' + decodeURIComponent(seg.replace(/&/g, '","').replace(/=/g, '":"')) + '"}')

   this file supersedes. That trick decoded first and split after, so the '&' above turned the
   segment into malformed JSON and JSON.parse threw during render - which unmounts the tree and
   leaves a blank page rather than an empty result list. It broke the same way on any value holding
   a '"' or a stray '%', and on any value that legitimately contained '=' or '&'.

Returns a plain object and NEVER throws: a missing, empty or unreadable segment gives {}, so a bad
URL degrades to "no filters" instead of taking the page down with it.
*/
export const parseSearchSegment = (pathname) => {
  try {
    // '/search-results/<keyword>/<filters>' -> ['', 'search-results', '<keyword>', '<filters>'].
    // A '/' inside the search text cannot widen this: encodeURIComponent writes it as %2F.
    const raw = String(pathname === undefined || pathname === null ? window.location.pathname : pathname).split('/')[3];
    if (!raw) return {};
    const out = {};
    new URLSearchParams(raw).forEach((value, key) => { out[key] = value; });
    return out;
  } catch (e) {
    // Unreachable in practice - URLSearchParams accepts any string - but this helper runs during
    // render on the buyer's main search path, so it is never the thing that breaks the page.
    return {};
  }
};

export default parseSearchSegment;
